// extracted by mini-css-extract-plugin
export default {"headerWrapper":"VL-z","header":"WL-z","hfImagesComponent":"XL-z","headerContainer":"YL-z"};